module.exports = __webpack_public_path__ + "static/media/company-03.90da950e.jpg";